import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'

const TitleTag = (props) => {
	let value

	if (props.title) {
		value = `${props.siteName} ${props.separator} ${props.title}`
	} else {
		value = props.siteName
	}

	return (
		<Helmet>
			<title>{value}</title>
		</Helmet>
	)
}

TitleTag.propTypes = {
	separator: PropTypes.string,
	siteName: PropTypes.string,
	title: PropTypes.string,
}

export default TitleTag


// WEBPACK FOOTER //
// ./src/common/components/meta/title-tag.js